var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-tooltip',{attrs:{"top":"","dark":""},scopedSlots:_vm._u([{key:"activator",fn:function(ref){
var on = ref.on;
return [_c('v-chip',_vm._g({staticClass:"account-chip",attrs:{"color":"primary","text-color":"white","selected":""},on:{"click":_vm.onClick}},on),[_c('v-avatar',[_c('v-icon',[_vm._v("account_circle")])],1),_vm._v(" "),_c('span',[_c('b',[_vm._v(_vm._s(_vm.snr))])])],1)]}}])},[_vm._v("\n  Open account details page\n")])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-dc9add24","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/baader/shared/AccountChip.vue
// module id = null
// module chunks = 